import Typography from '@mui/material/Typography';
import CheckCircleIcon from '@mui/icons-material/CheckCircleOutlined';
import Box from '@mui/material/Box';

const EnquirySubmissionSuccess = () =>
    (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                marginTop: 3
            }}
        >
            <CheckCircleIcon color="success" sx={{fontSize: 80, mb: 2}}/>
            <Typography variant="h4" gutterBottom>
                Thank you for your enquiry!
            </Typography>
            <Typography variant="body1">
                We will be in touch soon.
            </Typography>
        </Box>
    );

export default EnquirySubmissionSuccess;